import Navbar  from "../../NavBar/NavBar";
import Footer from "../..//Home/Footer.js"
import Whatsapp from "../../Home/Whatsapp.js";
import Spinner from "../../../components/Home/Spinner.js";
import Project2 from "./section_page/Project2.js";




const ArchitectureTextil = () =>{




    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <Project2/>
            <Footer/>
        </div>    
    )
};

export default ArchitectureTextil;